import type { RfqSupplySchedules } from "../../lib/api";
import { Checkbox } from "../beui/Checkbox";

export type SupplyScheduleDraft = Record<keyof RfqSupplySchedules, { quoted: boolean; text: string }>;

export function supplyScheduleInput(draft: SupplyScheduleDraft): RfqSupplySchedules | undefined {
  const fact = (value: SupplyScheduleDraft["delivery"]) => value.quoted ? { source: "quoted_terms" as const } : { source: "specified" as const, text: value.text.trim() };
  if (Object.values(draft).some(value => !value.quoted && value.text.trim().length < 3)) return undefined;
  return { delivery: fact(draft.delivery), condition: fact(draft.condition), inspectionRemedy: fact(draft.inspectionRemedy) };
}

export function RfqSupplyScheduleFields({ value, onChange }: { value: SupplyScheduleDraft; onChange: (value: SupplyScheduleDraft) => void }) {
  return <div className="space-y-3 border-t border-line pt-3">
    <p className="text-xs text-mut">For the supply agreement, record each arrangement here or identify it in your supply terms.</p>
    {([
      ["delivery", "Delivery arrangements", "delivery arrangements"],
      ["condition", "Condition and quality", "condition and quality"],
      ["inspectionRemedy", "Inspection and correction", "inspection and correction"],
    ] as const).map(([key, label, reference]) => <div key={key} className="space-y-2">
      <label className="block text-xs font-semibold text-navy">{label}<textarea className="field mt-1 h-20 resize-y py-2 text-base sm:text-sm" maxLength={2000} disabled={value[key].quoted} value={value[key].text} onChange={event => onChange({ ...value, [key]: { ...value[key], text: event.target.value } })} /></label>
      <Checkbox label={`Use supply terms for ${reference}`} checked={value[key].quoted} onCheckedChange={quoted => onChange({ ...value, [key]: { ...value[key], quoted } })} />
    </div>)}
  </div>;
}
